export const validateSlug = (slug: string) => {
  if (/(_{2,})|(-{2,})|(^_|^-)|(_$|-$)|(_-)|(-_)/g.test(slug)) {
    return false;
  }
  return /^[a-z0-9-_]+$/.test(slug);
};
